import React from 'react'

import { useFormContext, Controller } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import {
	useAlegraArgIdentificationTypes,
	useIvaConditionValues,
} from '@/core/hooks/misc/useAlegraConstants'
import { Label } from '@/shared/components/atoms/Label/Label'
import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from '@/shared/components/atoms/Select'

import { BillingInformationFormData } from '../BillingInformation.types'

interface AlegraArgFieldsProps {
	isEditMode?: boolean
}

export const AlegraArgFields: React.FC<AlegraArgFieldsProps> = ({
	isEditMode = false,
}) => {
	const { t } = useTranslation('common')
	const {
		control,
		formState: { errors },
	} = useFormContext<BillingInformationFormData>()
	const alegraArgIdentificationTypes = useAlegraArgIdentificationTypes()
	const ivaConditionValues = useIvaConditionValues()

	return (
		<>
			<div className="flex flex-col gap-2">
				<Label htmlFor="alegra_identification_type_arg">
					{t('account.billing_information.alegra_identification_type')} *
				</Label>
				<Controller
					name="alegra_identification_type_arg"
					control={control}
					render={({ field }) => (
						<Select
							value={field.value || ''}
							onValueChange={field.onChange}
							disabled={isEditMode}
						>
							<SelectTrigger
								className="bg-input w-full"
								aria-invalid={!!errors.alegra_identification_type_arg}
							>
								<SelectValue
									placeholder={t(
										'account.billing_information.select_identification_type'
									)}
								/>
							</SelectTrigger>
							<SelectContent>
								{alegraArgIdentificationTypes.map((type) => (
									<SelectItem key={type.value} value={type.value}>
										{type.label}
									</SelectItem>
								))}
							</SelectContent>
						</Select>
					)}
				/>
				{errors.alegra_identification_type_arg && (
					<p className="text-sm text-destructive">
						{errors.alegra_identification_type_arg.message}
					</p>
				)}
			</div>
			<div className="flex flex-col gap-2">
				<Label htmlFor="alegra_iva_condition">
					{t('account.billing_information.alegra_iva_condition')} *
				</Label>
				<Controller
					name="alegra_iva_condition"
					control={control}
					render={({ field }) => (
						<Select
							value={field.value || ''}
							onValueChange={field.onChange}
							disabled={isEditMode}
						>
							<SelectTrigger
								className="bg-input w-full"
								aria-invalid={!!errors.alegra_identification_type_arg}
							>
								<SelectValue
									placeholder={t(
										'account.billing_information.select_iva_condition'
									)}
								/>
							</SelectTrigger>
							<SelectContent>
								{ivaConditionValues.map((condition) => (
									<SelectItem key={condition.value} value={condition.value}>
										{condition.label}
									</SelectItem>
								))}
							</SelectContent>
						</Select>
					)}
				/>
				{errors.alegra_iva_condition && (
					<p className="text-sm text-destructive">
						{errors.alegra_iva_condition.message}
					</p>
				)}
			</div>
		</>
	)
}
